module.exports = __webpack_public_path__ + "static/media/img_push.b09597af.svg";